import { createSelector } from '@reduxjs/toolkit';

import { selectUserLicensesMap } from '@/domain/auth/auth.selectors.ts';
import { LicenseMode } from '@/domain/auth/entities/user.entity.ts';
import { RootState } from '@/domain/store';

import { CalculateOptions } from './entities/project-festival.entity';

export const selectIsFetchingProjectsFestival = (state: RootState) => {
  return state.projectFestival.isFetchingProjects;
};

export const selectIsCreatingProject = (state: RootState) => {
  return state.projectFestival.isCreatingProject;
};

export const selectIsFetchingCurrentProjectFestival = (state: RootState) => {
  return state.projectFestival.isFetchingCurrentProject;
};

export const selectProjectFestivalItems = (state: RootState) => {
  return state.projectFestival.items;
};

export const selectProjectFestivalItemsLength = (state: RootState) => {
  return state.projectFestival.items.length;
};

export const checkUserCreateFestival = createSelector(
  [selectProjectFestivalItemsLength, selectUserLicensesMap],
  (nbProjectFestival, userLicensesMap) => {
    const licenseFound = userLicensesMap.get(LicenseMode.FESTIVAL);
    return licenseFound && licenseFound.nbProjects > nbProjectFestival;
  },
);

export const selectProjectFestivalById = (id: number) => (state: RootState) => {
  const project = state.projectFestival.items.find(
    (project) => project.id === id,
  );
  return project;
};

export const selectCurrentProjectFestival = (state: RootState) => {
  return state.projectFestival.current;
};

export const selectIsEditingProjectFestival = (state: RootState) => {
  return state.projectFestival.isEditingProject;
};

export const selectProjectFestivalCurrentSector = (state: RootState) => {
  return state.projectFestival.currentSector;
};

export const selectProjectFestivalCurrentAverageCapacity = (
  state: RootState,
): number | undefined => {
  return state.projectFestival.current?.avgCapacity;
};

export const selectProjectFestivalCalculateOptions = (
  state: RootState,
): CalculateOptions | undefined => {
  return state.projectFestival.current?.calculateOptions;
};
